module.exports = __webpack_public_path__ + "img/rat.b8cc28d7.png";